// Full-page notice shown inside a partner iframe while waiting for, or after failing to get,
// a session from the parent. Never shows a login form — signing in happens top-level.

export default function EmbedNotice({ state }: { state: 'connecting' | 'failed' }) {
  // Strip embed-only params so the new tab opens the plain portal.
  const url = new URL(window.location.href)
  url.searchParams.delete('hide')

  return (
    <div
      id="embed-notice"
      data-qtz-part="embed-notice"
      className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark px-4"
    >
      {state === 'connecting' ? (
        <div className="flex items-center gap-3 text-subtle-light dark:text-subtle-dark">
          <span className="material-icons animate-spin">progress_activity</span>
          <span className="text-sm">Connecting…</span>
        </div>
      ) : (
        <div className="text-center space-y-3">
          <span className="material-icons text-4xl text-subtle-light dark:text-subtle-dark">link_off</span>
          <p className="text-sm text-text-light dark:text-text-dark">Session unavailable.</p>
          <a
            href={url.toString()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary dark:text-secondary hover:underline"
          >
            Open Quantizant Readiness in a new tab
            <span className="material-icons text-base">open_in_new</span>
          </a>
        </div>
      )}
    </div>
  )
}
